import { FormItemName } from '@framework/workbench/drawer/constants';
import { TDWOperationType, TDWActionType, TDWModuleType, EventCodeType, TDWVer8Type } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { ColorFrom } from '@tencent/workbench';
import { AngleFrom } from '@tencent/wb-ext-form';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import {
    IndentType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';

type IReportObj = {
    opername: string,
    module: string,
    action: string,
    eventcode: string,
    ver5?: number | string | null,
    ver6?: number | string,
    ver8?: number | string,
};

export type IOptions = {
    ver5?: number | string | null,
    ver6?: number | string,
    ver7?: number | string,
};

export type IValue = any;
export type IReportInfo = {
    reportId: string,
    value?: any,
    ver5?: number | string | null,
    ver6?: number | string,
    ver7?: number | string,
};

const getAppServices = (): IEditorAppServices => AppServiceProvider.getInstance().getAppServices() as
        IEditorAppServices;

export const tdwDrawerReport = (formItemKey: string, options?: IOptions) => {
    const selectedModel = getAppServices().viewableServiceLayer.selectionService.getSelectedModel();
    const reportObj = TdwDrawerConfigMap[formItemKey]?.(options);
    if (!reportObj) return;
    if (selectedModel?.type === UIModelType.MULTIPLY) {
        (selectedModel as IMultiplyModel).selectedModels?.forEach((element) => {
            reportObj.ver8 = getTdwSingleElementType(element);
            tdw(reportObj);
        });
        reportObj.ver8 = getTdwSingleElementType(selectedModel);
        tdw(reportObj);
    } else {
        reportObj.ver8 = getTdwSingleElementType(selectedModel);
        tdw(reportObj);
    }
};

export const tdwDrawerReportColor = (formItemKey: string, from: ColorFrom | number) => {
    const { color } = TdwDrawerConstMap;
    const colorMap = {
        [ColorFrom.DEFAULT]: color.default,
        [ColorFrom.RECENT]: color.recent,
        [color.picker]: color.picker,
    };
    if (colorMap[from]) {
        tdwDrawerReport(formItemKey, { ver5: colorMap[from] });
    }
    if (from === ColorFrom.CUSTOM) {
        tdwDrawerReport(formItemKey);
    }
};

export const tdwDrawerReportAngle = (formItemKey: string, from?: AngleFrom, value?: number) => {
    const { angle } = TdwDrawerConstMap;
    const angleMap = {
        [AngleFrom.ADD_BTN]: angle.btn,
        [AngleFrom.REDUCE_BTN]: angle.btn,
        [AngleFrom.INPUT]: angle.input,
        [AngleFrom.CIRCLE]: angle.circle,
    };
    if (from && angleMap[from]) {
        tdwDrawerReport(formItemKey, { ver5: angleMap[from], ver6: value });
    }
};

const getTdwSingleElementType = (selectedModel) => {
    // 1-从文本打开；2-此图形打开；3-从图片打开；4-从视频打开；5-从表格打开；6-从插件打开；7-从附件打开；8-从线条打开；9-从背景打开；10-从组合打开；99-多选元素；
    const TdwElementTypeMap = {
        [UIModelType.SHAPE]: () => {
            if (selectedModel.isAttachment()) { // 无预览图，附件
                return TDWVer8Type.FROM_ATTACHMENT;
            }
            if (selectedModel.isAddon) { // 插件
                return TDWVer8Type.FROM_ADDON;
            }
            if (selectedModel.isTextOrPlaceholder) {
                return TDWVer8Type.FROM_TEXT;
            }
            return TDWVer8Type.FROM_SHAPE;
        },
        [UIModelType.IMAGE]: (selectedModel.video ? TDWVer8Type.FROM_VIDEO : TDWVer8Type.FROM_IMAGE),
        [UIModelType.TABLE]: TDWVer8Type.FROM_TABLE,
        [UIModelType.CONNECTOR]: TDWVer8Type.FROM_CONNECTOR,
        [UIModelType.EMPTY]: TDWVer8Type.FROM_SLIDE,
        [UIModelType.GROUP]: TDWVer8Type.FROM_GROUP,
        [UIModelType.MULTIPLY]: TDWVer8Type.FROM_MULTIPLY,
    };
    const tdwElementType = TdwElementTypeMap[selectedModel?.type];
    return typeof tdwElementType === 'function' ? tdwElementType?.() : tdwElementType;
};

export const TdwDrawerConstMap = {
    fillType: {
        noFill: 1,
        solid: 2,
        gradual: 3,
        image: 4,
    },
    color: {
        default: 1, // 默认颜色
        recent: 2,  // 最近使用
        picker: 3,   // 取色器
    },
    angle: {
        circle: 1, // 轮盘
        input: 2,  // 输入框
        btn: 3,    // 上下按钮
    },
    numberInput: {
        input: 1,  // 输入框
        btn: 2,    // 上下按钮
    },
    arrowEnd: {
        head: 'head',  // 箭头-首端
        tail: 'tail',  // 箭头-末端
    },
    drawerOpen: 'drawerOpen',
    tabChange: 'tabChange',
    foldItem: 'foldItem',
    unfoldItem: 'unfoldItem',
    gradualAddPoint: 'gradualAddPoint',
    gradualRemovePoint: 'gradualRemovePoint',
    gradualRevertPoint: 'gradualRevertPoint',
    gradualPointColorChange: 'gradualPointColorChange',
    gradualRotateWithShape: 'gradualRotateWithShape',
    gradualFilllinerOrRadial: 'gradualFilllinerOrRadial',
    borderArrow: 'borderArrow',
    elementSize: 'elementSize', // 布局-大小-宽高
    elementScaleSize: 'elementScaleSize',   // 布局-大小-缩放宽高
    elementPositon: 'elementPositon',   // 布局-位置
    resetBg: 'resetBg',
    applyAllBg: 'applyAllBg',
    fontGradualFillLinerOrRadial: 'fontGradualFillLinerOrRadial',
    fontGradualPointColorChange: 'fontGradualPointColorChange',
    fontGradualAddPoint: 'fontGradualAddPoint',
    fontGradualRemovePoint: 'fontGradualRemovePoint',
    fontGradualRevertPoint: 'fontGradualRevertPoint',
    fontBorderGradualFillLinerOrRadial: 'fontBorderGradualFillLinerOrRadial',
    fontBorderGradualAddPoint: 'fontBorderGradualAddPoint',
    fontBorderGradualRemovePoint: 'fontBorderGradualRemovePoint',
    fontBorderGradualRevertPoint: 'fontBorderGradualRevertPoint',
    fontBorderGradualPointColorChange: 'fontBorderGradualPointColorChange',
    borderGradualFillLinerOrRadial: 'borderGradualFillLinerOrRadial',
    borderGradualAddPoint: 'borderGradualAddPoint',
    borderGradualRemovePoint: 'borderGradualRemovePoint',
    borderGradualRevertPoint: 'borderGradualRevertPoint',
    borderGradualPointColorChange: 'borderGradualPointColorChange',
};

export const NumberInputFromMap = {
    [AngleFrom.INPUT]: TdwDrawerConstMap.numberInput.input,
    [AngleFrom.ADD_BTN]: TdwDrawerConstMap.numberInput.btn,
    [AngleFrom.REDUCE_BTN]: TdwDrawerConstMap.numberInput.btn,
};

export const TdwDrawerConfigMap = {
    [TdwDrawerConstMap.drawerOpen]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR,
        action: TDWActionType.OPEN,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_OPEN,
    }),
    [TdwDrawerConstMap.tabChange]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR,
        action: TDWActionType.SWITCH,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_SWITCH,
    }),
    [TdwDrawerConstMap.foldItem]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR,
        action: TDWActionType.FOLD_ITEM,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FOLD_ITEM,
        ...options,
    }),
    [TdwDrawerConstMap.unfoldItem]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR,
        action: TDWActionType.UNFOLD_ITEM,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_UNFOLD_ITEM,
        ...options,
    }),
    [FormItemName.FILL_PRESET]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_SHORTCUT,
        ...options,
    }),
    [FormItemName.FILL_SELECT]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.SET,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_SET,
        ...options,
    }),
    [FormItemName.SOLID_FILL_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_STYLE_FILL,
                action: TDWActionType.SOLID_COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_SOLID_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_STYLE_FILL,
            action: TDWActionType.SOLID_CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_SOLID_CUSTOM_COLOR,
        });
    },
    [FormItemName.SOLID_FILL_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.SOLID_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_SOLID_TRANS,
        ...options,
    }),
    [TdwDrawerConstMap.gradualFilllinerOrRadial]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_TYPE,
        ...options,
    }),
    [FormItemName.GRADUAL_FILL_ANGLE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_ANGLE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_ANGLE,
        ...options,
    }),
    [FormItemName.GRADUAL_FILL_DIRECTION]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_POS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_POS,
        ...options,
    }),
    [TdwDrawerConstMap.gradualAddPoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_ADD_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_ADD_COLOR,
    }),
    [TdwDrawerConstMap.gradualRemovePoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_DE_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_DE_COLOR,
    }),
    [TdwDrawerConstMap.gradualRevertPoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_RE_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_RE_COLOR,
    }),
    [TdwDrawerConstMap.gradualPointColorChange]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_EDIT_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_EDIT_COLOR,
        ...options,
    }),
    [FormItemName.GRADUAL_FILL_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_TRANS,
        ...options,
    }),
    [TdwDrawerConstMap.gradualRotateWithShape]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_FILL,
        action: TDWActionType.GRADIENT_ROTATE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_FILL_GRADIENT_ROTATE,
    }),
    [FormItemName.BORDER_PRESET]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SHORTCUT,
        ...options,
    }),
    [FormItemName.BORDER_SELECT]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_TYPE,
        ...options,
    }),
    [FormItemName.BORDER_LINE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.SOLID_TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_TYPE,
        ...options,
    }),
    [FormItemName.BORDER_WIDTH]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.SOLID_SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_SIZE,
        ...options,
    }),
    [FormItemName.BORDER_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_STYLE_BORDER,
                action: TDWActionType.SOLID_COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_STYLE_BORDER,
            action: TDWActionType.SOLID_CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_CUSTOM_COLOR,
        });
    },
    [TdwDrawerConstMap.borderArrow]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.POINT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_POINT,
        ...options,
    }),
    [FormItemName.BORDER_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.SOLID_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_TRANS,
        ...options,
    }),
    [TdwDrawerConstMap.borderGradualFillLinerOrRadial]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.GRADIENT_TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_TYPE,
        ...options,
    }),
    [FormItemName.BORDER_GRADUAL_ANGLE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.GRADIENT_ANGLE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_ANGLE,
        ...options,
    }),
    [FormItemName.BORDER_GRADUAL_DIRECTION]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.GRADIENT_POS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_POS,
        ...options,
    }),
    [TdwDrawerConstMap.borderGradualAddPoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.GRADIENT_ADD_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_ADD_COLOR,
    }),
    [TdwDrawerConstMap.borderGradualRemovePoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.GRADIENT_DE_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_DE_COLOR,
    }),
    [TdwDrawerConstMap.borderGradualRevertPoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.GRADIENT_RE_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_RE_COLOR,
    }),
    [TdwDrawerConstMap.borderGradualPointColorChange]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.GRADIENT_EDIT_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_EDIT_COLOR,
        ...options,
    }),
    [FormItemName.BORDER_GRADUAL_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_BORDER,
        action: TDWActionType.GRADIENT_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_GRADIENT_TRANS,
        ...options,
    }),
    [FormItemName.SHADOW]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_SHADOW,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SHADOW_SHORTCUT,
        ...options,
    }),
    [FormItemName.SHADOW_SIZE]: (options?: IOptions | IValue): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_SHADOW,
        action: TDWActionType.SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SHADOW_SIZE,
        ...options,
    }),
    [FormItemName.SHADOW_BLUR]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_SHADOW,
        action: TDWActionType.BLUR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SHADOW_BLUR,
        ...options,
    }),
    [FormItemName.SHADOW_DISTANCE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_SHADOW,
        action: TDWActionType.DISTANCE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SHADOW_DISTANCE,
        ...options,
    }),
    [FormItemName.SHADOW_OPICITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_SHADOW,
        action: TDWActionType.TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SHADOW_TRANS,
        ...options,
    }),
    [FormItemName.SHADOW_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_STYLE_SHADOW,
                action: TDWActionType.COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SHADOW_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_STYLE_SHADOW,
            action: TDWActionType.CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SHADOW_CUSTOM_COLOR,
        });
    },
    [FormItemName.REFLECTION]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_GLOW,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_GLOW_SHORTCUT,
        ...options,
    }),
    [FormItemName.REFLECTION_SIZE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_GLOW,
        action: TDWActionType.SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_GLOW_SIZE,
        ...options,
    }),
    [FormItemName.REFLECTION_BLUR]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_GLOW,
        action: TDWActionType.BLUR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_GLOW_BLUR,
        ...options,
    }),
    [FormItemName.REFLECTION_DISTANCE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_GLOW,
        action: TDWActionType.DISTANCE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_GLOW_DISTANCE,
        ...options,
    }),
    [FormItemName.REFLECTION_OPICITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_GLOW,
        action: TDWActionType.TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_GLOW_TRANS,
        ...options,
    }),
    [FormItemName.GLOW]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_LUMINE,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_LUMINE_SHORTCUT,
        ...options,
    }),
    [FormItemName.GLOW_SIZE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_LUMINE,
        action: TDWActionType.SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_LUMINE_SIZE,
        ...options,
    }),
    [FormItemName.GLOW_OPICITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_LUMINE,
        action: TDWActionType.TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_LUMINE_TRANS,
        ...options,
    }),
    [FormItemName.GLOW_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_STYLE_LUMINE,
                action: TDWActionType.COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_LUMINE_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_STYLE_LUMINE,
            action: TDWActionType.CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_LUMINE_CUSTOM_COLOR,
        });
    },
    [FormItemName.SOFT_EDGE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_SOFTEN,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SOFTEN_SHORTCUT,
        ...options,
    }),
    [FormItemName.SOFT_EDGE_SIZE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_STYLE_SOFTEN,
        action: TDWActionType.SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_SOFTEN_SIZE,
        ...options,
    }),
    [FormItemName.FONT]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.FONT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_FONT,
    }),
    [ActionType.FORECOLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_TEXT_FONT,
                action: TDWActionType.COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_TEXT_FONT,
            action: TDWActionType.CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_CUSTOM_COLOR,
        });
    },
    [ActionType.FONTSIZE_UP]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.INCREASE_SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_INCREASE_SIZE,
    }),
    [ActionType.FONTSIZE_DOWN]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.DECREASE_SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_DECREASE_SIZE,
    }),
    [FormItemName.FONT_BACK_COLOR]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.HIGHLIGHT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_HIGHLIGHT,
    }),
    [ActionType.BOLD]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.BOLD,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_BOLD,
    }),
    [ActionType.ITALIC]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.ITALIC,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_ITALIC,
    }),
    [ActionType.UNDERLINE]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.UNDERLINE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_UNDERLINE,
    }),
    [ActionType.DELETELINE]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.STRIKE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_STRIKE,
    }),
    [ActionType.SUBSCRIPT]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.SUBSCRIPT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_SUBSCRIPT,
    }),
    [ActionType.SUPERSCRIPT]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_FONT,
        action: TDWActionType.SUPERSCRIPT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_FONT_SUPERSCRIPT,
    }),
    [ActionType.HORIZONTAL_ALIGN]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_PARAGRAPH,
        action: TDWActionType.H_ALIGN,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_H_ALIGN,
        ...options,
    }),
    [ActionType.VERTICAL_ALIGN]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_PARAGRAPH,
        action: TDWActionType.V_ALIGN,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_V_ALIGN,
        ...options,
    }),
    [ActionType.INDENT]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_PARAGRAPH,
        action: TDWActionType.INDENT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_INDENT,
        ver5: options?.ver5 === IndentType.INDENT_INCREASE ? 1 : 2,
    }),
    [ActionType.INDENT]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_PARAGRAPH,
        action: TDWActionType.INDENT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_INDENT,
        ver5: options?.ver5 === IndentType.INDENT_INCREASE ? 1 : 2,
    }),
    [ActionType.ITEMNUMBER]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_PARAGRAPH,
        action: TDWActionType.BULLETS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_BULLETS,
        ...options,
    }),
    [ActionType.DIGITNUMBER]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_PARAGRAPH,
        action: TDWActionType.NUMBERING,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_NUMBERING,
        ...options,
    }),
    [ActionType.ROW_SPACE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_PARAGRAPH,
        action: TDWActionType.LINE_SPACING,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_PARAGRAPH_LINE_SPACING,
        ...options,
    }),
    [FormItemName.FONT_ADJUST]: (options?: IOptions | IValue): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_BOX,
        action: TDWActionType.AUTO_ADJUST,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_BOX_AUTO_ADJUST,
        ...options,
    }),
    [FormItemName.TEXT_DIRECTION]: (options?: IOptions | IValue): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_BOX,
        action: TDWActionType.DIRECTION,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_BOX_DIRECTION,
        ...options,
    }),
    [ActionType.PADDING_ADJUST]: (options?: IOptions | IValue): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_BOX,
        action: TDWActionType.PADDING,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_BOX_PADDING,
        ...options,
    }),
    [ActionType.TEXT_ADJUST]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_TEXT_BOX,
        action: TDWActionType.AUTO_WRAP,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_TEXT_BOX_AUTO_WRAP,
    }),
    [ActionType.ALIGN_HORIZONTALLT_LEFT]: () => hAlignReport(1),
    [ActionType.ALIGN_HORIZONTALLT_CENTER]: () => hAlignReport(2),
    [ActionType.ALIGN_HORIZONTALLT_RIGHT]: () => hAlignReport(3),
    [ActionType.ALIGN_VERTICALLY_TOP]: () => vAlignReport(1),
    [ActionType.ALIGN_VERTICALLY_CENTER]: () => vAlignReport(2),
    [ActionType.ALIGN_VERTICALLY_BOTTOM]: () => vAlignReport(3),
    [ActionType.ALIGN_DISTRIBUTE_HORIZONTALLT]: () => distributeReport(1),
    [ActionType.ALIGN_DISTRIBUTE_VERTICALLY]: () => distributeReport(2),
    [ActionType.SELECT_WINDOW]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_LEVEL,
        action: TDWActionType.ALL,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_LEVEL_ALL,
    }),
    [ActionType.MOVETOP]: () => moveLevelReport(1),
    [ActionType.MOVEBOTTOM]: () => moveLevelReport(2),
    [ActionType.MOVEUP]: () => moveLevelReport(3),
    [ActionType.MOVEDOWN]: () => moveLevelReport(4),
    [ActionType.ADDGROUP]: () => groupReport(1),
    [ActionType.REMOVEGROUP]: () => groupReport(2),
    [TdwDrawerConstMap.elementSize]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_SIZE,
        action: TDWActionType.SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_SIZE_SIZE,
        ...options,
    }),
    [TdwDrawerConstMap.elementScaleSize]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_SIZE,
        action: TDWActionType.ZOOM,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_SIZE_ZOOM,
        ...options,
    }),
    [ActionType.SIZE_ADJUST]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_SIZE,
        action: TDWActionType.LOCK_RATE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_SIZE_LOCK_RATE,
    }),
    [FormItemName.LAYOUT_ROTATE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_ROTATE,
        action: TDWActionType.ROTATE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_ROTATE_ROTATE,
        ...options,
    }),
    [ActionType.BORDERSTYLE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_ROTATE,
        action: TDWActionType.ROTATE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_ROTATE_ROTATE,
        ...options,
    }),
    [FormItemName.PICTURE_OPACITY]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_PICTURE_EDIT,
        action: TDWActionType.TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_PICTURE_EDIT_TRANS,
    }),
    [FormItemName.PICTURE_FIX_RESET]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_PICTURE_CORRECTION,
        action: TDWActionType.RESET,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_PICTURE_CORRECTION_RESET,
    }),
    [FormItemName.SHARPEN_SOFTEN]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_PICTURE_CORRECTION,
        action: TDWActionType.CLARITY,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_PICTURE_CORRECTION_CLARITY,
        ...options,
    }),
    [FormItemName.BRIGHTNESS]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_PICTURE_CORRECTION,
        action: TDWActionType.BRIGHTNESS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_PICTURE_CORRECTION_BRIGHTNESS,
        ...options,
    }),
    [FormItemName.CONSTRAST]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_PICTURE_CORRECTION,
        action: TDWActionType.CONTRAST,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_PICTURE_CORRECTION_CONTRAST,
        ...options,
    }),
    [FormItemName.PICTURE_COLOR_RESET]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_PICTURE_EFFECT,
        action: TDWActionType.RESET,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_PICTURE_EFFECT_RESET,
    }),
    [FormItemName.SATURATE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_PICTURE_EFFECT,
        action: TDWActionType.SATURATION,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_PICTURE_EFFECT_SATURATION,
        ...options,
    }),
    [FormItemName.COLOR_TEMPERATURE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_PICTURE_EFFECT,
        action: TDWActionType.TEMPERATURE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_PICTURE_EFFECT_TEMPERATURE,
        ...options,
    }),
    [TdwDrawerConstMap.resetBg]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_BACKGROUND,
        action: TDWActionType.RESET,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_BACKGROUND_RESET,
    }),
    [TdwDrawerConstMap.applyAllBg]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_BACKGROUND,
        action: TDWActionType.APPLY_ALL,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_BACKGROUND_APPLY_ALL,
    }),
    [FormItemName.TABLE_BORDER_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_TABLE_BORDER,
                action: TDWActionType.COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_TABLE_BORDER_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_TABLE_BORDER,
            action: TDWActionType.CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_TABLE_BORDER_CUSTOM_COLOR,
        });
    },
    [TdwDrawerConstMap.elementPositon]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_POS,
        action: TDWActionType.POS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_POS_POS,
        ...options,
    }),
    [FormItemName.RESET_ORIGINAL_SIZE]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_SIZE,
        action: TDWActionType.PIC_RESIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_SIZE_PIC_RESIZE,
    }),
    [FormItemName.RELATIVE_IMAGE_ORIGINAL_SIZE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_LAYOUT_SIZE,
        action: TDWActionType.PIC_SIZE_ORIGINAL,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_SIZE_PIC_SIZE_ORIGINAL,
        ...options,
    }),
    // 文本填充
    [FormItemName.FONT_FILL_PRESET]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_SHORTCUT,
        ...options,
    }),
    [FormItemName.FONT_FILL_SELECT]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.SET,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_SET,
        ...options,
    }),
    [FormItemName.FONT_SOLID_FILL_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_FONT_FILL,
                action: TDWActionType.SOLID_COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_SOLID_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_FONT_FILL,
            action: TDWActionType.SOLID_CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_SOLID_CUSTOM_COLOR,
        });
    },
    [FormItemName.FONT_SOLID_FILL_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.SOLID_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_SOLID_TRANS,
        ...options,
    }),
    [TdwDrawerConstMap.fontGradualFillLinerOrRadial]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.GRADIENT_TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_TYPE,
        ...options,
    }),
    [FormItemName.FONT_GRADUAL_FILL_ANGLE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.GRADIENT_ANGLE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_ANGLE,
        ...options,
    }),
    [FormItemName.FONT_GRADUAL_FILL_DIRECTION]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.GRADIENT_POS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_POS,
        ...options,
    }),
    [TdwDrawerConstMap.fontGradualAddPoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.GRADIENT_ADD_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_ADD_COLOR,
    }),
    [TdwDrawerConstMap.fontGradualRemovePoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.GRADIENT_DE_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_DE_COLOR,
    }),
    [TdwDrawerConstMap.fontGradualRevertPoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.GRADIENT_RE_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_RE_COLOR,
    }),
    [TdwDrawerConstMap.fontGradualPointColorChange]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.GRADIENT_EDIT_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_EDIT_COLOR,
        ...options,
    }),
    [FormItemName.FONT_GRADUAL_FILL_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.GRADIENT_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_TRANS,
        ...options,
    }),
    [FormItemName.FONT_IMAGE_FILL_CLIPBOARD]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.PIC_PASTE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_PIC_PASTE,
        ...options,
    }),
    [FormItemName.FONT_IMAGE_FILL_UPLOAD]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.PIC_UPLOAD,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_PIC_UPLOAD,
        ...options,
    }),
    [FormItemName.FONT_IMAGE_FILL_STYLE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.PIC_TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_PIC_TYPE,
        ...options,
    }),
    [FormItemName.FONT_IMAGE_FILL_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_FILL,
        action: TDWActionType.PIC_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_PIC_TRANS,
        ...options,
    }),
    // 文本效果
    [FormItemName.FONT_SHADOW]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_SHADOW,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_SHADOW_SHORTCUT,
        ...options,
    }),
    [FormItemName.FONT_SHADOW_SIZE]: (options?: IOptions | IValue): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_SHADOW,
        action: TDWActionType.SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_SHADOW_SIZE,
        ...options,
    }),
    [FormItemName.FONT_SHADOW_BLUR]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_SHADOW,
        action: TDWActionType.BLUR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_SHADOW_BLUR,
        ...options,
    }),
    [FormItemName.FONT_SHADOW_DISTANCE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_SHADOW,
        action: TDWActionType.DISTANCE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_SHADOW_DISTANCE,
        ...options,
    }),
    [FormItemName.FONT_SHADOW_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_SHADOW,
        action: TDWActionType.TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_SHADOW_TRANS,
        ...options,
    }),
    [FormItemName.FONT_SHADOW_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_FONT_SHADOW,
                action: TDWActionType.COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_SHADOW_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_FONT_SHADOW,
            action: TDWActionType.CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_SHADOW_CUSTOM_COLOR,
        });
    },
    [FormItemName.FONT_REFLECTION]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_GLOW,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_GLOW_SHORTCUT,
        ...options,
    }),
    [FormItemName.FONT_REFLECTION_SIZE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_GLOW,
        action: TDWActionType.SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_GLOW_SIZE,
        ...options,
    }),
    [FormItemName.FONT_REFLECTION_BLUR]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_GLOW,
        action: TDWActionType.BLUR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_GLOW_BLUR,
        ...options,
    }),
    [FormItemName.FONT_REFLECTION_DISTANCE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_GLOW,
        action: TDWActionType.DISTANCE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_GLOW_DISTANCE,
        ...options,
    }),
    [FormItemName.FONT_REFLECTION_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_GLOW,
        action: TDWActionType.TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_GLOW_TRANS,
        ...options,
    }),
    [FormItemName.FONT_GLOW]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_LUMINE,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_LUMINE_SHORTCUT,
        ...options,
    }),
    [FormItemName.FONT_GLOW_SIZE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_LUMINE,
        action: TDWActionType.SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_LUMINE_SIZE,
        ...options,
    }),
    [FormItemName.FONT_GLOW_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_LUMINE,
        action: TDWActionType.TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_LUMINE_TRANS,
        ...options,
    }),
    [FormItemName.FONT_GLOW_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_FONT_LUMINE,
                action: TDWActionType.COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_LUMINE_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_FONT_LUMINE,
            action: TDWActionType.CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_LUMINE_CUSTOM_COLOR,
        });
    },
    [FormItemName.FONT_BORDER_PRESET]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.SHORTCUT,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_SHORTCUT,
        ...options,
    }),
    [FormItemName.FONT_BORDER_LINE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.SOLID_TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_SOLID_TYPE,
        ...options,
    }),
    [FormItemName.FONT_BORDER_SELECT]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_TYPE,
        ...options,
    }),
    [FormItemName.FONT_BORDER_WIDTH]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.SOLID_SIZE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_SOLID_SIZE,
        ...options,
    }),
    [FormItemName.FONT_BORDER_COLOR]: (options?: IOptions): IReportObj => {
        if (options?.ver5) {
            return ({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.SIDEBAR_FONT_BORDER,
                action: TDWActionType.SOLID_COLOR,
                eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_COLOR,
                ...options,
            });
        }
        return ({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.SIDEBAR_FONT_BORDER,
            action: TDWActionType.SOLID_CUSTOM_COLOR,
            eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_CUSTOM_COLOR,
        });
    },
    [FormItemName.FONT_BORDER_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.SOLID_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_STYLE_BORDER_SOLID_TRANS,
        ...options,
    }),
    [TdwDrawerConstMap.fontBorderGradualFillLinerOrRadial]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.GRADIENT_TYPE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_TYPE,
        ...options,
    }),
    [FormItemName.FONT_BORDER_GRADUAL_ANGLE]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.GRADIENT_ANGLE,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_ANGLE,
        ...options,
    }),
    [FormItemName.FONT_BORDER_GRADUAL_DIRECTION]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.GRADIENT_POS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_POS,
        ...options,
    }),
    [TdwDrawerConstMap.fontBorderGradualAddPoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.GRADIENT_ADD_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_ADD_COLOR,
    }),
    [TdwDrawerConstMap.fontBorderGradualRemovePoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.GRADIENT_DE_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_DE_COLOR,
    }),
    [TdwDrawerConstMap.fontBorderGradualRevertPoint]: (): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.GRADIENT_RE_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_RE_COLOR,
    }),
    [TdwDrawerConstMap.fontBorderGradualPointColorChange]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.GRADIENT_EDIT_COLOR,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_BORDER_GRADIENT_EDIT_COLOR,
        ...options,
    }),
    [FormItemName.FONT_BORDER_GRADUAL_OPACITY]: (options?: IOptions): IReportObj => ({
        opername: TDWOperationType.DOC_PPT,
        module: TDWModuleType.SIDEBAR_FONT_BORDER,
        action: TDWActionType.GRADIENT_TRANS,
        eventcode: EventCodeType.DOC_PPT_SIDEBAR_FONT_FILL_GRADIENT_TRANS,
        ...options,
    }),
};

const hAlignReport = (ver5): IReportObj => ({
    opername: TDWOperationType.DOC_PPT,
    module: TDWModuleType.SIDEBAR_LAYOUT_ALIGN,
    action: TDWActionType.H_ALIGN,
    eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_ALIGN_H_ALIGN,
    ver5,
});

const vAlignReport = (ver5): IReportObj => ({
    opername: TDWOperationType.DOC_PPT,
    module: TDWModuleType.SIDEBAR_LAYOUT_ALIGN,
    action: TDWActionType.V_ALIGN,
    eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_ALIGN_V_ALIGN,
    ver5,
});

const distributeReport = (ver5): IReportObj => ({
    opername: TDWOperationType.DOC_PPT,
    module: TDWModuleType.SIDEBAR_LAYOUT_ALIGN,
    action: TDWActionType.DISTRIBUTE,
    eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_ALIGN_DISTRIBUTE,
    ver5,
});

const moveLevelReport = (ver5): IReportObj => ({
    opername: TDWOperationType.DOC_PPT,
    module: TDWModuleType.SIDEBAR_LAYOUT_LEVEL,
    action: TDWActionType.ADJUST,
    eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_LEVEL_ADJUST,
    ver5,
});

const groupReport = (ver5): IReportObj => ({
    opername: TDWOperationType.DOC_PPT,
    module: TDWModuleType.SIDEBAR_LAYOUT_GROUP,
    action: TDWActionType.GROUP,
    eventcode: EventCodeType.DOC_PPT_SIDEBAR_LAYOUT_GROUP_GROUP,
    ver5,
});
